import { environment } from '@api-ui-app/src/environments/environment';

export const getAppVersion = (): string => `${environment.version} (gelato-api-ui)`;
